import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { ReactComponent as ArrowsPointingOut } from 'assets/icons/ArrowsPointingOut.svg';

export interface IFullscreenButtonProps {
  className?: string;
  isFullscreen: boolean;
  toggleFullscreen: VoidFunction;
}

export const FullscreenButton: FC<IFullscreenButtonProps> = ({ className, isFullscreen, toggleFullscreen }) => {
  const { t } = useTranslation();
  return (
    <Button
      className={className}
      onClick={toggleFullscreen}
      variant="contained"
      size="large"
      endIcon={!isFullscreen && <ArrowsPointingOut />}
    >
      {isFullscreen ? t('backToEditing') :  t('fullScreenLow') }
    </Button>
  );
};
